/**
 * @fileoverview Prospect metadata query hook.
 * @description Wraps GET /tenants/prospect-metadata in a TanStack query. The catalogues change
 * rarely, so a read stays fresh for five minutes.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getProspectMetadata } from '@/features/sales/services/prospect-metadata.service'

const FIVE_MINUTES_MS = 5 * 60 * 1000

/**
 * @description Fetches the prospect metadata catalogues.
 * @returns {ReturnType<typeof useQuery>} The query (data is every catalogue and the tier scheme).
 */
export function useProspectMetadata() {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.metadata,
    queryFn: getProspectMetadata,
    staleTime: FIVE_MINUTES_MS,
  })
}
